export const setDisplay =currentMetaData =>{
    return {
        type:'SET_DISPLAY',
        payload:currentMetaData
    }
}
